import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { map, observeOn, filter } from 'rxjs/operators';
import { Observable, asyncScheduler } from 'rxjs';
import { httpInProgress } from 'projects/bis-shared/src/lib/redux/http-status/http-status.selector';
import { some, isEmpty } from 'lodash';
import { IdentityEntityGroup } from 'projects/bis-shared/src/lib/auth/security-models';
import { Roles } from 'projects/bis-shared/src/lib/utility/roles';
import { NavigationStart, NavigationEnd, Router } from '@angular/router';
import { ModalComponent } from '../modal/modal.component';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  providers: [MdbModalService],
})
export class NavigationComponent {
  readonly EntityType = EntityTypeCode;
  httpInProgress$: Observable<boolean>;

  showInAppItems: boolean;
  showAccount: boolean;
  showSubmitRequest: boolean;
  showNewPriorAuth: boolean;
  showNewHp1: boolean;
  onLoginOrLogoutScreen: boolean;
  currentRoute: string;
  browserName: any;

  AppUrls = AppUrls;

  modalRef: MdbModalRef<ModalComponent>;
  constructor(
    store: Store,
    identityService: IdentityService,
    router: Router,
    private modalService: MdbModalService,
  ) {
    identityService.isLoggedIn$.subscribe(isLoggedIn => {
      this.showInAppItems = isLoggedIn;
      if (this.showInAppItems) {
        const ua = navigator.userAgent;
        let tem, tem1;
        const M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])) {
          this.modalRef = this.modalService.open(ModalComponent);
        }
        if (M[1] === 'Chrome') {
          tem = ua.match(/\bEdg\/(\d+)/);
          tem1 = ua.match(/\bOPR\/(\d+)/);
          if (tem != null) {
            if (parseFloat(tem[1]) < 110) {
              this.modalRef = this.modalService.open(ModalComponent);
            }
          } else if (tem1 != null) {
            this.modalRef = this.modalService.open(ModalComponent);
          } else if (M[1] === 'Chrome' && parseFloat(M[2]) < 110) {
            this.modalRef = this.modalService.open(ModalComponent);
          }
        } else if (M[1] === 'Firefox' && parseFloat(M[2]) < 110) {
          this.modalRef = this.modalService.open(ModalComponent);
        } else if (M[1] === 'Safari') {
          const safariVersionMatch = ua.match(/Version\/(\d+)/i);
          if (parseFloat(safariVersionMatch[1]) < 15) {
            this.modalRef = this.modalService.open(ModalComponent);
          }
        } else if ((tem = ua.match(/Version\/(\d+)/i)) != null) {
          //M.splice(1, 1, tem[1]); - commented
          if (parseFloat(tem[1]) < 15) {
            this.modalRef = this.modalService.open(ModalComponent);
          }
        }
      }
    });
    router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.onLoginOrLogoutScreen = event.url === '/login' || event.url === '/logout';
      });
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.url.split('#')[0];
      });
    this.httpInProgress$ = store.select(httpInProgress).pipe(observeOn(asyncScheduler));
    identityService.identity$.pipe(map(identity => identity?.entityGroups)).subscribe(eg => {
      const filteredGroups = eg?.filter(g => some(g?.userRoleCodes));
      const entityTypes = filteredGroups
        ? new Set<EntityTypeCode>(filteredGroups.map(g => g.entityTypeCode))
        : new Set<EntityTypeCode>();

      this.showAccount = !isEmpty(filteredGroups);
      this.showNewPriorAuth = some(
        filteredGroups,
        (g: IdentityEntityGroup) =>
          g.entityTypeCode === EntityTypeCode.HealthcareProvider &&
          some(g.userRoleCodes, (r: Roles) => !isEmpty(r) && r !== Roles.HPBillingDelegate),
      );
      this.showNewHp1 =
        entityTypes.has(EntityTypeCode.HealthcareProvider) ||
        entityTypes.has(EntityTypeCode.MedicalSupplier);

      this.showSubmitRequest = this.showNewPriorAuth || this.showNewHp1;
    });
  }
}
